export default (nodeList) => Array.prototype.slice.call(nodeList);
